var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumWhole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".PremiumWhole_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "PremiumWhole_svg__b",
    d: "M5.984 21H4a1 1 0 01-1-1v-6a1 1 0 011-1h1.984a1 1 0 011 1v6a1 1 0 01-1 1zM12.96 17h2.324a1.984 1.984 0 001.195-.4l2.406-1.812a1.5 1.5 0 011.972.141 1.519 1.519 0 010 2.142l-2.064 2.073a3.98 3.98 0 01-2.036 1.094l-2.919.586a3.968 3.968 0 01-1.748-.042l-2.639-.662a3.927 3.927 0 00-.966-.12h-1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "PremiumWhole_svg__b",
    d: "M12.96 17h1.479a1.512 1.512 0 001.509-1.515v-.3a1.512 1.512 0 00-1.143-1.469l-2.283-.573A4.665 4.665 0 0011.388 13a4.657 4.657 0 00-2.594.789L6.984 15M15.286 3.661l-.349.373-.35-.373a2.086 2.086 0 00-2.887-.153 2.131 2.131 0 00-.257 2.943A20.518 20.518 0 0014.937 10a20.7 20.7 0 003.57-3.645 2.048 2.048 0 00-.287-2.807l-.038-.033a2.09 2.09 0 00-2.9.146z"
  })));
}
export default SvgPremiumWhole;


//////////////////
// WEBPACK FOOTER
// ./src/icons/PremiumWhole.svg
// module id = 547
// module chunks = 115